import { useCallback, useState } from "react";

type BoolSwitchUpdate = {
  setTrue: VoidFunction;
  setFalse: VoidFunction;
};

export const useBoolSwitch = (defaultState = false): [boolean, BoolSwitchUpdate] => {
  const [boolState, setBool] = useState(defaultState);
  const setTrue = useCallback(() => setBool(true), [setBool]);
  const setFalse = useCallback(() => setBool(false), [setBool]);

  return [boolState, { setTrue, setFalse }];
};
